import Markdown from "markdown-to-jsx";
import styles from "./secondDiferentialsSecond.module.css";

export default function SectionDiferenctialsSecond({ data }) {
  return (
    <>
      <section className={`container-full ${styles.container}`}>
        <div className={styles.parallelogram} />
        <div className={`grid-cont align-self-center ${styles.content}`}>
          <div className={styles.diferentials}>
            {data.diferenciais.map((item) => {
              return (
                <>
                  <div className={styles.difContent}>
                    <div className={styles.difImg}>
                      <img src={item.icone.url} width={54} height={54} />
                    </div>
                    <div className={styles.diferential}>
                      <div>
                        <h2>{item.titulo}</h2>
                        <Markdown>{item.texto}</Markdown>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </section>
      <div className="container-full justify-content-center">
        <div className={`grid-cont ${styles.bg}`}></div>
      </div>
    </>
  );
}
